<div class="message-box">
    <ul>
        @for (msg of sortedMessages(); let i = $index; track $index) {
        @if (shouldShowDateDivider(i)) { <li class="date-divider">{{ formatDate(msg.Timestamp) }}</li> }
        <li [ngClass]="getMessageClass(msg, i)">{{ msg.Message }}</li>
        }
        @empty {
        <li class="no-messages">{{noCommentsText()}}</li>
        }
    </ul>
</div>

<div class="input-box">
    <app-textbox [name]="$safeNavigationMigration(conversation()?.Id)+'-text'" [(ngModel)]="messageText" caption="" [disabled]="readonly()"></app-textbox>
    <app-button primary (click)="postNewMessage()" [disabled]="!messageText || readonly()">Send</app-button>
</div>  